import {Component, Input, OnInit} from '@angular/core';
import {TabViewCustom} from '../../../_models/tab-view-custom';
import {SelectItem} from 'primeng/api';
import {FlujoVentaPaso} from '../../../_models/flujo-venta-paso';

@Component({
  selector: 'app-flujo-venta-seguro',
  templateUrl: './flujo-venta-seguro.component.html',
  styleUrls: ['./flujo-venta-seguro.component.css']
})
export class FlujoVentaSeguroComponent implements OnInit {

  @Input() tabView: TabViewCustom;
  @Input() listaSecuencias: SelectItem[] = [];
  @Input() listaVinculaciones: SelectItem[] = [];
  @Input() listaTiposPersonas: SelectItem[] = [];
  @Input() lisPasos: FlujoVentaPaso[] = [];
  @Input() titulo: string;

  tabSeleccionado = "DATGEN";

  constructor() {}

  ngOnInit() {}

  abrirAcordeon(evento: number) {
    switch (evento) {
      case 0: {
        this.tabSeleccionado = "DATGEN";
        break;
      }
      case 1: {
        this.tabSeleccionado = "RESPERXVIN";
        break;
      }
    }
  }

}
